// @flow
import Trpc from 'digicel-kaizen-library/lib/tripica-library';
import type { PortabilityCharacteristics } from 'digicel-kaizen-library';
import type { SignUpPhoneNumberActionType } from './actions';
import { phoneNumberSelector } from '../AvailablePhoneNumbers';
import type { StateType } from '../../reducers';
import config from '../../../config';
import { regionSelector } from '../Region/selectors';

// $FlowFixMe flow est perdu
export const initialState: PhoneNumberStateType = {};

export default (state: PhoneNumberStateType = initialState, action: SignUpPhoneNumberActionType) => {
  switch (action.type) {
    case 'SIGNUP_SET_PICKED_PHONE_NUMBER':
      return {
        number: action.payload.number,
        ouid: action.payload.ouid,
      };
    case 'SIGNUP_SET_KEPT_PHONE_NUMBER':
      const { number, rio } = action.payload;
      return {
        number: number.replace(/[^\d+]/g, ''),
        rio,
      };
    case 'SIGNUP_CLEAR_CHOSEN_PHONE_NUMBER':
      return initialState;

    default:
      return state;
  }
};

const phoneNumberStateSelector = (state: StateType): PhoneNumberStateType => state.signUp.phoneNumber;

export const chosenPhoneNumberSelector = (state: StateType): ?string => {
  const phoneNumberState: PhoneNumberStateType = phoneNumberStateSelector(state);
  if (phoneNumberState.number) {
    return phoneNumberState.number;
  }
  const phoneNumberObject = phoneNumberState.ouid && phoneNumberSelector(state, phoneNumberState.ouid);
  return phoneNumberObject && phoneNumberObject.phoneNumber;
};

export const choosenPhoneNumberOuidSelector = (state: StateType): ?string => {
  const phoneNumberState = phoneNumberStateSelector(state);
  return phoneNumberState.ouid;
};

const isKeepingNumberSelector = (state: StateType): boolean => {
  return !choosenPhoneNumberOuidSelector(state);
};

export const portabilityCharacteristicsSelector = (
  state: StateType,
  getInternationalFormat: ?boolean
): ?PortabilityCharacteristics => {
  const isKeepingNumber = isKeepingNumberSelector(state);
  if (!isKeepingNumber) return null;
  let phoneNumber = chosenPhoneNumberSelector(state);
  if (!phoneNumber) return null;
  if (getInternationalFormat) {
    const region = regionSelector(state);
    if (region) {
      phoneNumber = config.LOCAL_PHONE_INDICATIVE[region.name] + phoneNumber.substr(1);
    }
  }

  return { ...Trpc.buildPortaInCharacs(phoneNumber), portabilityCode: phoneNumberStateSelector(state).rio };
};

export const internationalFormatPortabilityCharacteristicsSelector = (
  state: StateType
): ?PortabilityCharacteristics => {
  return portabilityCharacteristicsSelector(state, true);
};

export type PhoneNumberStateType = {|
  number?: string,
  operator?: string,
  ouid?: string,
  rio?: string,
|};
